import { frozen } from "./scroll.css";

/**
 * Toggle freezing of the stream. Used while modals are open.
 */
export default (function () {
  if (typeof document !== "undefined") {
    var body = document.querySelector("body");

    if (body && body.classList) {
      if (body.classList.contains(frozen)) {
        body.classList.remove(frozen);
      } else {
        body.classList.add(frozen);
      }
    }
  }
});

export var freezeScroll = function freezeScroll() {
  if (typeof document !== "undefined") {
    var body = document.querySelector("body");

    if (body && body.classList) {
      body.classList.add(frozen);
    }
  }
};

export var thawScroll = function thawScroll() {
  if (typeof document !== "undefined") {
    var body = document.querySelector("body");

    if (body && body.classList) {
      body.classList.remove(frozen);
    }
  }
};


// WEBPACK FOOTER //
// ./src/utils/toggleScroll.js